class ImageLink {
  constructor($imageLink) {
    this.$imageLink = $imageLink;
    this.$url = this.$imageLink.href;
    this.setUrl();
  }

  setUrl() {
    this.$imageLink.style.setProperty('--url', `url(${this.$url})`);
  }
}

const addImageLink = () => {
  const imageLinks = document.querySelectorAll('[data-image-link]');

  if (imageLinks.length) {
    imageLinks.forEach((imageLink) => {
      new ImageLink(imageLink);
    });
  }
};

export { addImageLink };
